export const SERVICES_LIST = [
  {
    id: 1,
    name: 'Account Services',
    count: 156,
  },
  {
    id: 2,
    name: 'Resources',
    count: 142,
  },
  {
    id: 3,
    name: 'Coaching',
    count: 87,
  },
  {
    id: 4,
    name: 'Boosting',
    count: 63,
  },
  {
    id: 5,
    name: 'Other Services',
    count: 214,
  },
];

export const OUR_CONTACT_INFO = {
  DISCORD_LINK: 'https://discord.gg/MHHw7g4CKk',
  EMAIL_LINK: 'saintlucifer0786@gmail.com'
}